<script setup lang="ts">
// Métadonnées de la page produits suivis
useHead({
  title: 'Produits suivis - Glouton',
  meta: [
    { name: 'description', content: 'Suivez vos produits préférés et soyez informé des meilleures aubaines. Ne manquez jamais une bonne affaire.' },
    { property: 'og:title', content: 'Produits suivis - Glouton' },
    { property: 'og:description', content: 'Suivez vos produits préférés et soyez informé des meilleures aubaines. Ne manquez jamais une bonne affaire.' },
  ],
})
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/my-tracked-ingredients',
    fr: '/produits-suivis',
  },
})

definePageMeta({
  name: 'TrackedIngredientsPage',
})

const userStore = useUserStore()
const config = useRuntimeConfig()
const route = useRoute()
const localePath = useLocalePath()
const toast = useToast()

// your explicit refs
const totalResults = ref(0)

const tabs = computed(() => {
  return [
    {
      label: 'Circulaires',
      to: localePath({ name: 'FlyersPage' }),
      active: route.name === 'FlyersPage___fr' || route.name === 'FlyerPage___fr',
      extra: false,
    },
    {
      label: 'Produits suivis',
      to: localePath({ name: 'TrackedIngredientsPage' }),
      active: route.name === 'TrackedIngredientsPage___fr',
      extra: true,
    },
  ]
})

const subtabs = [
  { label: 'Résultats', value: 'preview' },
  { label: 'Réglages', value: 'settings' },

]

const currentTab = ref('preview')
const showHelp = ref(false)
const isLoading = ref(false)
const isSearchLoading = ref(false)
const isFlyerItemsLoading = ref(false)
const alertStatus = ref(false)
const includeSummary = ref(false)
const ingredients = ref([])
const suggestions = ref([])
const alertIngredients = ref([])
const searchResults = ref([])
const searchString = ref('')
const displayMode = ref('list')
const startDate = ref('')
const endDate = ref('')
const isSettingsSaving = ref(false)
const alertStatusUpdated = ref(false)
const debounce = ref(false)
const selectedPeriod = ref('current')
const futureAvailable = ref(false)

// Computed property for period options
const periodOptions = computed(() => {
  return [
    { label: 'Offres en vigueur', value: 'current' },
    {
      label: 'Offres à venir',
      value: 'future',
      disabled: !futureAvailable.value,
    },
  ]
})

// Fetch settings
async function fetchSettings() {
  try {
    isLoading.value = true
    const response = await $fetch(`${config.public.apiUrl}/custom-flyer-alert/fetch-settings`, {
      headers: {
        Authorization: `Bearer ${userStore.access_token}`,
      },
    })
    ingredients.value = response.ingredients
    suggestions.value = response.suggestions
    alertStatus.value = response.settings.status
    includeSummary.value = response.settings.include_summary
  }
  catch (e) {
    console.error(e)
    isLoading.value = false
  }
  finally {
    isLoading.value = false
  }
}

// Fetch flyer items
async function fetchFlyerItems() {
  try {
    isFlyerItemsLoading.value = true
    const response = await $fetch(`${config.public.apiUrl}/custom-flyer-alert/fetch-flyer-items`, {
      query: {
        period: selectedPeriod.value,
      },
      headers: {
        Authorization: `Bearer ${userStore.access_token}`,
      },
    })
    alertIngredients.value = response.alert_ingredients
    startDate.value = response.start_date
    endDate.value = response.end_date
    futureAvailable.value = response.future_available || false
  }
  catch (e) {
    console.error(e)
  }
  finally {
    isFlyerItemsLoading.value = false
  }
}

async function searchIngredients(e) {
  console.log('search', e)
  try {
    isSearchLoading.value = true
    const response = await $fetch(`${config.public.apiUrl}/custom-flyer-alert/search-ingredients`, {
      method: 'GET',
      query: {
        q: e.value,
      },
      headers: {
        Authorization: `Bearer ${userStore.access_token}`,
      },
    })

    isSearchLoading.value = false
    searchResults.value = response
  }
  catch (err) {
    isSearchLoading.value = false
    console.log(err)
  }
}

// Save settings
async function saveSettings() {
  try {
    isSettingsSaving.value = true
    const response = await $fetch(`${config.public.apiUrl}/custom-flyer-alert/save-settings`, {
      method: 'POST',
      body: { ingredients: ingredients.value, status: alertStatus.value },
      headers: {
        Authorization: `Bearer ${userStore.access_token}`,
      },
    })
    if (response.success === 1) {
      toast.add({
        title: 'Sauvegardé avec succès',
        description: 'Vos produits suivis ont été mis à jour.',
        icon: 'i-lucide-check-circle',
        color: 'success',
      })
    }
    else {
      toast.add({
        title: 'Une erreur s\'est produite',
        description: 'Les produits n\'ont pas été sauvegardés. Vérifiez votre connexion ou contactez le support.',
        icon: 'i-lucide-alert-circle',
        color: 'error',
      })
    }
  }
  catch (e) {
    console.error(e)
  }
  finally {
    isSettingsSaving.value = false
  }
}

function containsObject(id, list) {
  let i
  for (i = 0; i < list.length; i++) {
    if (list[i].id === id)
      return true
  }

  return false
}

function removeIngredient(id) {
  for (let i = 0; i < ingredients.value.length; i++) {
    const obj = ingredients.value[i]

    if (obj.id === id)
      ingredients.value.splice(i, 1)
  }
}
function addIngredient(id, name) {
  if (containsObject(id, ingredients.value)) {
    toast.add({
      title: 'Produit déjà sélectionné',
      description: 'Ce produit fait déjà partie de vos produits suivis.',
      icon: 'i-lucide-alert-circle',
      color: 'error',
    })
  }
  else if (ingredients.value.length >= 40) {
    toast.add({
      title: 'Limite atteinte',
      description: 'Vous suivez déjà 40 produits. Veuillez en retirer avant d\'en ajouter d\'autres.',
      icon: 'i-lucide-alert-circle',
      color: 'error',
    })
  }
  else {
    ingredients.value.push({ id, name })
  }
}

function updateField(e) {
  // this.searchString = e.srcElement.value
  isSearchLoading.value = true
  clearTimeout(debounce)
  debounce.value = setTimeout(() => {
    searchIngredients(searchString)
  }, 300)
}

async function saveAlertSettings() {
  try {
    const response = await $fetch(`${config.public.apiUrl}/custom-flyer-alert/save-settings`, {
      method: 'POST',
      body: { status: alertStatus.value },
      headers: {
        Authorization: `Bearer ${userStore.access_token}`,
      },
    })
    console.log(response)
    if (response.success == 1) {
      if (alertStatus.value) {
        toast.add({
          title: 'Alertes activées',
          description: 'Vous recevrez un courriel tous les mercredis.',
          icon: 'i-lucide-check-circle',
          color: 'success',
        })
      }
      else {
        toast.add({
          title: 'Alertes désactivées',
          description: 'Vous ne recevrez plus de courriel les mercredis.',
          icon: 'i-lucide-check-circle',
          color: 'success',
        })
      }
    }
    else {
    }
    return response
  }
  catch (err) {
  }
}

watch(currentTab, (tab) => {
  if (tab === 'preview')
    fetchFlyerItems()
})

watch(selectedPeriod, () => {
  if (currentTab.value === 'preview')
    fetchFlyerItems()
})

watch(alertStatus, (val) => {
  if (alertStatusUpdated.value)
    saveAlertSettings()
})

onMounted(() => {
  if (userStore.user) {
    fetchSettings()
    fetchFlyerItems()
  }
})

// Watcher pour recharger les données quand le statut utilisateur change
watch(() => userStore.user, (newUser, oldUser) => {
  // Si l'utilisateur passe de null/false à un objet utilisateur
  if (newUser && !oldUser) {
    fetchSettings()
    fetchFlyerItems()
  }
}, { immediate: false })
</script>

<template>
  <div id="TrackedIngredientsPage">
    <TopNav
      title="Produits suivis"
      description="Repérez facilement les meilleures aubaines sur vos produits favoris."
      :total="totalResults"
      :show-help-button="userStore.user && userStore.user.extra == 1"
      :help-status="showHelp"
      :tabs="tabs"
      class="max-w-8xl mx-auto"
      access="Un abonnement Extra est requis pour utiliser cet outil."
      @help-button-click="showHelp = !showHelp"
    />
    <div v-if="userStore.user && userStore.user.extra == 1 && !showHelp" class="relative">
      <UContainer id="TrackedIngredientsPage-anchor">
        <div class="px-0 mx-auto max-w-8xl pb-4">
          <!-- Tabs -->
          <UTabs v-model="currentTab" color="primary" :content="false" :items="subtabs" class="my-4" size="xl" :ui="{ list: ' bg-white' }" />

          <!-- Loading States -->
          <div v-if="(currentTab === 'settings' && isLoading) || (currentTab === 'preview' && isFlyerItemsLoading)" class="text-center my-6">
            <UIcon name="i-mdi-loading" class="animate-spin text-venice h-6 w-6 mx-auto" />
          </div>

          <!-- PREVIEW Tab -->
          <div v-if="currentTab === 'preview' && !isFlyerItemsLoading">
            <UAlert
              v-if="selectedPeriod === 'future'"
              color="info"
              variant="soft"
              size="lg"
              icon="i-mdi-information"
              class="mb-4"
              orientation="horizontal"
              description="Les offres proviennent des circulaires à venir, certaines peuvent ne pas être encore disponibles ou analysées."
            />
            <UAlert
              v-else
              color="secondary"
              variant="soft"
              size="lg"
              icon="i-mdi-store"
              class="mb-4"
              orientation="horizontal"
              :description="`Résultats pour vos ${userStore.user?.stores?.length || 0} commerces favoris`"
              :actions="[
                {
                  label: 'Modifier',
                  color: 'secondary',
                  variant: 'soft',
                  to: localePath({ name: 'UserProfilePage' }),
                },
              ]"
            />
            <!-- Warning when no products are selected -->
            <div v-if="ingredients.length === 0" class="text-center p-6 bg-white rounded-lg shadow mb-4">
              <UIcon name="i-lucide-alert-triangle" class="mx-auto h-12 w-12 text-amber-500 mb-4" />
              <h3 class="text-lg font-semibold text-poivre-800 mb-2">
                Aucun produit suivi
              </h3>
              <p class="text-sm text-poivre-600 mb-4">
                Ajoutez votre premier produit suivi dans les réglages.
              </p>
              <UButton
                color="secondary"
                icon="i-mdi-cog"
                label="Réglages"
                @click="currentTab = 'settings'"
              />
            </div>

            <div v-else>
              <div class="flex justify-between mb-4">
                <UFieldGroup>
                  <UButton color="secondary" active-variant="solid" variant="soft" icon="i-mdi-view-grid" :active="displayMode == 'grid'" class="px-3" @click="displayMode = 'grid'" />
                  <UButton color="secondary" active-variant="solid" variant="soft" icon="i-mdi-view-list" :active="displayMode == 'list'" class="px-3" @click="displayMode = 'list'" />
                </UFieldGroup>

                <USelect
                  v-model="selectedPeriod"
                  :items="periodOptions"
                  class="w-48"
                  icon="i-mdi-calendar"
                />
              </div>

              <!-- GRID VIEW -->
              <div v-if="displayMode === 'grid'">
                <div v-for="ingredient in alertIngredients" :key="ingredient.id" class="mb-5">
                  <div class="text-base border-b border-gray-200 font-medium py-2 text-poivre-800 flex items-center space-x-2 justify-start mb-4">
                    <h2>{{ ingredient.ingredient.name }}</h2>
                    <UBadge color="secondary" variant="soft" size="sm">
                      {{ ingredient.flyer_items.length }}
                    </UBadge>
                  </div>
                  <div v-if="ingredient.flyer_items.length === 0">
                    Aucun produit détecté dans les épiceries liées à votre profil.
                  </div>
                  <ul v-else class="grid gap-6 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                    <FlyerItemCard
                      v-for="(item, key) in ingredient.flyer_items"
                      :key="item.id"
                      :position="key"
                      :item="item"
                    />
                  </ul>
                </div>
              </div>

              <!-- LIST VIEW -->
              <div v-if="displayMode === 'list'">
                <div v-for="ingredient in alertIngredients" :key="ingredient.id" class="mb-5 bg-white rounded-md shadow overflow-hidden">
                  <div class="text-base border-b border-gray-200 font-medium px-3 py-2 text-poivre-800 flex items-center space-x-2 justify-start">
                    <h2>{{ ingredient.ingredient.name }}</h2>
                    <UBadge color="secondary" variant="soft" size="sm">
                      {{ ingredient.flyer_items.length }}
                    </UBadge>
                  </div>
                  <div class="bg-white">
                    <div v-if="ingredient.flyer_items.length === 0" class="py-2 px-4">
                      Aucun produit détecté dans les épiceries liées à votre profil.
                    </div>
                    <ul v-else class="divide-y divide-gray-200">
                      <FlyerItemListCard
                        v-for="(item, key) in ingredient.flyer_items"
                        :key="item.id"
                        :position="key"
                        :item="item"
                      />
                    </ul>
                  </div>
                </div>

                <div class="mb-5 bg-white rounded-md shadow">
                  <h2 class="text-base border-b border-gray-200 px-4 py-2 font-medium text-poivre-800">
                    Tous les rabais
                  </h2>
                  <div class="p-4 text-base text-poivre">
                    Pour tous les rabais évalués et faire des recherches, consultez notre outil
                    <ULink class="text-tomate underline inline-flex" :to="$localePath({ name: 'FlyersPage' })">
                      Circulaires
                    </ULink>.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SETTINGS Tab -->
          <div v-if="currentTab === 'settings' && !isLoading">
            <div class="bg-white rounded-md shadow px-4 py-5 mb-4">
              <div class="flex items-center justify-between">
                <div>
                  <h3 class="text-lg font-semibold text-poivre-800 mb-1">
                    Alertes de prix par courriel
                  </h3>
                  <p class="text-sm text-poivre-500">
                    Recevez chaque mercredi un résumé des meilleures aubaines pour vos ingrédients favoris par courriel.
                    Les alertes sont
                    <span :class="alertStatus ? 'text-green-500' : 'text-red-500'">
                      {{ alertStatus ? 'actives' : 'désactivées' }}
                    </span>.
                  </p>
                </div>
                <USwitch v-model="alertStatus" size="lg" color="tertiary" @click="alertStatusUpdated = true" />
              </div>
            </div>

            <!-- Ingredients Selection -->
            <div class="bg-white rounded-md shadow px-4 py-5 mb-4">
              <p class="mb-4 text-base text-poivre">
                Vous pouvez sélectionner jusqu'à 40 produits. Les résultats sont pour les <ULink class="text-tomate-500 underline" :to="$localePath({ name: 'UserProfilePage' })">
                  épiceries liées à votre profil
                </ULink>.
              </p>

              <h4 class="text-lg font-medium text-poivre-700 mb-2">
                Produits sélectionnés ({{ ingredients.length }})
              </h4>
              <div class="flex flex-wrap gap-2 mb-4">
                <div v-if="ingredients.length === 0" class="text-poivre-400">
                  Aucun produit sélectionné.
                </div>
                <UBadge
                  v-for="ingredient in ingredients"
                  :key="ingredient.id"
                  variant="soft"
                  class="flex items-center"
                  size="lg"
                  color="tertiary"
                >
                  {{ ingredient.name }}
                  <UButton icon="i-mdi-close" size="xs" color="primary" variant="ghost" @click="removeIngredient(ingredient.id)" />
                </UBadge>
              </div>

              <h4 class="text-lg font-medium text-poivre-700 mb-2">
                Ajouter des ingrédients
              </h4>

              <UInput
                v-model="searchString"
                placeholder="Rechercher un ingrédient..."
                icon="i-mdi-magnify"
                :loading="isSearchLoading"
                class="mb-4 w-full xl:max-w-sm"
                @input="updateField"
              >
                <template v-if="searchString?.length" #trailing>
                  <UButton
                    color="neutral"
                    variant="link"
                    size="sm"
                    icon="i-lucide-x"
                    aria-label="Clear input"
                    @click="searchString = ''"
                  />
                </template>
              </UInput>

              <div class="flex flex-wrap gap-2 mb-4">
                <template v-if="searchString !== ''">
                  <div v-if="!isSearchLoading && searchResults.length === 0" class="text-red-500">
                    Aucun résultat pour cette recherche.
                  </div>
                  <UBadge
                    v-for="suggestion in searchResults"
                    :key="suggestion.id"
                    variant="soft"
                    class="flex items-center"
                    size="lg"
                    color="tertiary"
                  >
                    {{ suggestion.name }}
                    <UButton icon="i-mdi-plus" size="xs" color="primary" variant="ghost" @click="addIngredient(suggestion.id, suggestion.name)" />
                  </UBadge>
                </template>
                <template v-else>
                  <UBadge
                    v-for="suggestion in suggestions"
                    :key="suggestion.ingredient.id"
                    variant="soft"
                    class="flex items-center"
                    size="lg"
                    color="tertiary"
                  >
                    {{ suggestion.ingredient.name }}
                    <UButton icon="i-mdi-plus" size="xs" color="green" variant="ghost" @click="addIngredient(suggestion.ingredient.id, suggestion.ingredient.name)" />
                  </UBadge>
                </template>
              </div>

              <div class="text-right">
                <UButton :loading="isSettingsSaving" color="primary" @click="saveSettings">
                  Sauvegarder
                </UButton>
              </div>
            </div>
          </div>
        </div>
      </UContainer>
    </div>
    <div v-else class="py-6">
      <TrackedIngredientsHelp />
    </div>
  </div>
</template>
